"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));

var _date = _interopRequireDefault(require("@spothero/utils/date"));

var _DatePickerCalendarNavigation = _interopRequireDefault(require("./DatePickerCalendarNavigation"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var DATE = new Date();

var DatePickerCalendar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DatePickerCalendar, _Component);

  function DatePickerCalendar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DatePickerCalendar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DatePickerCalendar).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      selectedDate: _this.props.selectedDate
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onDaySelected", function (day, _ref, evt) {
      var selected = _ref.selected,
          disabled = _ref.disabled;

      if (disabled) {
        return;
      }

      var onChange = _this.props.onChange;
      var selectedDate = (0, _moment.default)(day).format('MM/DD/YYYY');

      _this.setState({
        selectedDate: selectedDate
      });

      if (onChange) {
        onChange(selectedDate);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_modifierSelected", function (day) {
      var selectedDate = _this.state.selectedDate;

      if (!(0, _isEmpty.default)(selectedDate)) {
        return _reactDayPicker.DateUtils.isSameDay(_date.default.getAsDate(selectedDate), day);
      } else {
        return null;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_modifierDisabled", function (day) {
      var _this$props = _this.props,
          disablePast = _this$props.disablePast,
          disableBefore = _this$props.disableBefore,
          disableAfter = _this$props.disableAfter;
      var isDayDisabled = false;
      var disableDay = false;

      if (disableBefore) {
        disableDay = _date.default.isBefore(day, _date.default.getAsDate(disableBefore));
        isDayDisabled = disableDay;
      }

      if (disableAfter && !isDayDisabled) {
        disableDay = _date.default.isAfter(day, _date.default.getAsDate(disableAfter));
        isDayDisabled = disableDay;
      }

      if (disablePast && !isDayDisabled) {
        disableDay = _reactDayPicker.DateUtils.isPastDay(day);
      }

      return disableDay;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_renderDayMarkup", function (day) {
      var m = (0, _moment.default)(day);
      var date = "".concat(m.format('MM'), "/").concat(m.format('DD'), "/").concat(m.format('YYYY'));
      return _react.default.createElement("span", {
        "data-date": date
      }, day.getDate());
    });
    _this._weekdayTitles = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    return _this;
  }

  (0, _createClass2.default)(DatePickerCalendar, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          initialMonth = _this$props2.initialMonth,
          disablePast = _this$props2.disablePast,
          disableBefore = _this$props2.disableBefore,
          disableAfter = _this$props2.disableAfter,
          overrideInitialMonthWithSelected = _this$props2.overrideInitialMonthWithSelected;
      var selectedDate = this.state.selectedDate;
      var classes = (0, _classnames.default)('DatePicker-calendar', className);
      var firstMonth = initialMonth;
      var fromMonth = disablePast ? DATE : null;
      var toMonth = null;

      if (disableBefore) {
        var beforeDate = _date.default.getAsDate(disableBefore);

        if (fromMonth) {
          if (_date.default.isAfter(beforeDate, fromMonth)) {
            fromMonth = beforeDate;
          }
        } else {
          fromMonth = beforeDate;
        }

        firstMonth = fromMonth;
      }

      if (disableAfter) {
        toMonth = _date.default.getAsDate(disableAfter);
      }

      if (selectedDate && overrideInitialMonthWithSelected) {
        firstMonth = _date.default.getAsDate(selectedDate);
      }

      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_reactDayPicker.default, {
        selectedDays: this._modifierSelected,
        disabledDays: this._modifierDisabled,
        onDayClick: this._onDaySelected,
        fromMonth: fromMonth,
        toMonth: toMonth,
        initialMonth: firstMonth,
        renderDay: this._renderDayMarkup,
        weekdaysShort: this._weekdayTitles,
        navbarElement: _react.default.createElement(_DatePickerCalendarNavigation.default, null),
        showOutsideDays: true
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return DatePickerCalendar;
}(_react.Component);

exports.default = DatePickerCalendar;
(0, _defineProperty2.default)(DatePickerCalendar, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /**
   * Function to execute when the selected date changes.
   *
   * @param {String} selectedDate - The selected date in the format 'MM/DD/YYYY'.
   */
  onChange: _propTypes.default.func,

  /** A string in the format 'MM/DD/YYYY' representing the date which should be selected on the calendar. */
  selectedDate: _propTypes.default.string,

  /** A date object representing the initial month to show on the calendar. */
  initialMonth: _propTypes.default.instanceOf(Date),

  /** Whether to disable the days on the calendar that are in the past. */
  disablePast: _propTypes.default.bool,

  /** A string in the format 'MM/DD/YYYY' representing the date where any day prior is disabled. */
  disableBefore: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the date where any day past is disabled. */
  disableAfter: _propTypes.default.string,

  /** Whether to set the initial month to show in the calendar to the same month as the selected day falls within when a selectedDate is passed. */
  overrideInitialMonthWithSelected: _propTypes.default.bool
});
(0, _defineProperty2.default)(DatePickerCalendar, "defaultProps", {
  selectedDate: '',
  initialMonth: DATE,
  disablePast: true,
  overrideInitialMonthWithSelected: true
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DATE, "DATE", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/DatePickerCalendar.jsx");
  reactHotLoader.register(DatePickerCalendar, "DatePickerCalendar", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/DatePickerCalendar.jsx");
  leaveModule(module);
})();

;